import { TableDataProperties } from '../../../shared/uiComponents/Table/tableProperties';

export enum ScheduleReportStatus {
	Completed = 0,
	OutstandingNoSession = 1,
	OutstandingSoapMissing = 2,
	OutstandingDraftExpired = 3,
	CancelledSingleSession = 4,
	CancelledExtendedTimeOff = 5,
	Scheduled = 6,
}

export interface GetScheduleReportProperties {
	cancellationStatusFilter?: string;
	caseManagerId?: string;
	clientIds?: string[];
	direction: string;
	endDate: string;
	orderBy: string;
	page: string;
	pageSize: string;
	providerId?: string;
	searchString: string;
	sessionTypeIds?: string[];
	startDate: string;
	statuses?: string[];
}

export interface ScheduleReportRowProperties {
	authorizedHours: number | null;
	branchId: string | null;
	branchName: string | null;
	cancelledHours: number;
	cancellationId: string | null;
	cancellationReason: string | null;
	cancellationStatus: number | null;
	cancellationType: number | null;
	cancellingParty: number | null;
	caseManagerId: string | null;
	caseManagerName: string | null;
	clientId: string | null;
	clientName: string | null;
	isElc: boolean;
	completedHours: number;
	providerId: string | null;
	providerEmail: string | null;
	providerName: string | null;
	providerRoleSection: number | null;
	recurringScheduleId: string | null;
	reportId: string | null;
	rescheduleIntent: number | null;
	scheduledEndTimeMinutes: number | null;
	scheduledHours: number;
	scheduledStartTimeMinutes: number | null;
	serviceDate: string;
	sessionEndTime: string | null;
	sessionId: string | null;
	sessionStartTime: string | null;
	sessionTypeId: number | null;
	sessionTypeName: string | null;
	soapExpirationDate: string | null;
	soapStatus: number | null;
	soapSubmittedAt: string | null;
	status: ScheduleReportStatus;
	utilizationPercentage: number | null;
}

export interface ScheduleCancellationReportRowProperties {
	branchId: string | null;
	branchName: string | null;
	cancellationId: string;
	cancellingParty: number | null;
	caseManagerId: string | null;
	caseManagerName: string | null;
	clientId: string | null;
	clientName: string | null;
	isElc: boolean;
	createdById: string;
	createdByName: string | null;
	createdAt: string;
	endDate: string;
	groupId: string | null;
	origin: number;
	providerId: string;
	providerName: string | null;
	providerRoleSection: number | null;
	reasonId: number | null;
	reasonName: string | null;
	recurringScheduleId: string | null;
	rescheduleIntent: number | null;
	reviewedAt: string | null;
	reviewedById: string | null;
	reviewedByName: string | null;
	startDate: string;
	status: number;
	type: number;
}

export interface ScheduleUtilizationReportRowProperties {
	branchId: string | null;
	branchName: string | null;
	cancelledHours: number;
	caseManagerId: string | null;
	caseManagerName: string | null;
	clientId: string | null;
	clientName: string | null;
	isElc: boolean;
	completedHours: number;
	notCompletedHours: number;
	providerId: string | null;
	providerName: string | null;
	providerRoleSection: number | null;
	scheduleAdherencePercentage: number | null;
	scheduledHours: number;
	sessionTypeId: number | null;
	sessionTypeName: string | null;
}

export interface ScheduleAllotmentReportRowProperties {
	authUtilizationPercentage: number | null;
	branchId: string | null;
	branchName: string | null;
	caseManagerId: string | null;
	caseManagerName: string | null;
	clientId: string;
	clientName: string | null;
	isElc: boolean;
	clientStatusId: number;
	clientStatusName: string | null;
	hasSchedule: boolean;
	totalAuthorizedHours: number;
	totalScheduledHours: number;
}

export interface GetScheduleAllotmentReportProperties {
	asOfDate?: string;
	branchId?: string;
	caseManagerId?: string;
	clientIds?: string[];
	direction: string;
	orderBy: string;
	page: string;
	pageSize: string;
	providerId?: string;
	searchString: string;
}

export interface ScheduleReportRowsProperties extends TableDataProperties {
	query: ScheduleReportRowProperties[] | null;
}

export interface ScheduleCancellationReportRowsProperties extends TableDataProperties {
	query: ScheduleCancellationReportRowProperties[] | null;
}

export interface ScheduleUtilizationReportRowsProperties extends TableDataProperties {
	query: ScheduleUtilizationReportRowProperties[] | null;
}

export interface ScheduleAllotmentReportRowsProperties extends TableDataProperties {
	query: ScheduleAllotmentReportRowProperties[] | null;
}

export interface ScheduleReportCacheStatusProperties {
	branchId: string | null;
	cacheRefreshId: string | null;
	canRefresh: boolean;
	completedAt: string | null;
	nextRefreshAvailableAt: string | null;
	dateRangeEnd: string | null;
	dateRangeStart: string | null;
	errorMessage: string | null;
	isAvailable: boolean;
	isRunning: boolean;
	rowsGenerated: number;
	startedAt: string | null;
	status: number | null;
}
